/* Veda: adds the small line mark next to "Veda Fusion" (cut swoosh) and "Veda Flow" (unbroken swoosh)
   on buttons, tabs and short headings in the page content. Header and footer menus get the mark via CSS (v36). */
(function () {
  if (window.__vedaMarks) return; window.__vedaMarks = true;
  var tpl = { fusion: null, flow: null };
  function load() {
    var t = document.getElementById('v-mark-tpl'); if (!t) return false;
    tpl.fusion = t.content.querySelector('.v-mark--fusion');
    tpl.flow = t.content.querySelector('.v-mark--flow');
    return !!(tpl.fusion && tpl.flow);
  }
  var SEL = 'a, button, [role="tab"], summary, h1, h2, h3, .v-tab, .v-eyebrow, .v-looks__line, label';
  var SKIP = '[data-no-mark], .v-rte, .v-lb__text, .v-lede, p:not(.v-eyebrow), script, style, template, #header-group, header, header-component, header-drawer, .header, .menu-drawer, footer, .v-foot, #shopify-section-footer, [id*="__veda_footer"], [id*="footer"]';
  function kindOf(text) {
    if (/veda\s+fusion/i.test(text)) return 'fusion';
    if (/veda\s+flow/i.test(text)) return 'flow';
    return null;
  }
  function unmark() {
    document.querySelectorAll('.v-mark').forEach(function (m) {
      if (!m.closest(SKIP)) return;
      var el = m.parentElement; m.remove();
      if (el) { el.classList.remove('v-has-mark'); }
    });
  }
  function mark(root) {
    if (!tpl.fusion && !load()) return;
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.vMarked || el.closest(SKIP)) return;
      if (el.querySelector('.v-mark')) { el.dataset.vMarked = 1; return; }
      var text = (el.textContent || '').trim();
      if (!text || text.length > 48) return;
      var k = kindOf(text); if (!k) return;
      var inner = [].some.call(el.querySelectorAll(SEL), function (c) { return kindOf(c.textContent || ''); });
      if (inner) return;
      var svg = tpl[k].cloneNode(true);
      el.dataset.vMarked = 1;
      el.classList.add('v-has-mark');
      el.insertBefore(svg, el.firstChild);
    });
  }
  /* header + footer menus: expose the two marks as CSS mask images (drawn by veda-polish.css) */
  function cssMarks() {
    if (document.documentElement.classList.contains('v-mk-ready') || (!tpl.fusion && !load())) return;
    var ser = new XMLSerializer();
    ['fusion', 'flow'].forEach(function (k) {
      var svg = tpl[k].cloneNode(true);
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.removeAttribute('class');
      var uri = 'url("data:image/svg+xml,' + encodeURIComponent(ser.serializeToString(svg)) + '")';
      document.documentElement.style.setProperty('--v-mk-' + k, uri);
    });
    document.documentElement.classList.add('v-mk-ready');
  }
  function run() { cssMarks(); unmark(); mark(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if ('MutationObserver' in window) {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
